import React, { useEffect, useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";
import ReactDOM from "react-dom";
import { REACTIONS } from "../../Constants/AINewsConstants";
import AddFeedbackIcon from "./AddFeedbackIcon";

const AIReactionModal = ({ text, handleReaction, parentText, isInsights, isMiniListOpen, stopTranslate, isPedigree, translateX = 150, arrowTransformX = 9, onVisibilityChange = () => {} }) => {
  const popoverRef = useRef(null);
  const reactionRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const selectedEmojiRef = useRef(selectedEmoji);
  const [comments, setComments] = useState("");
  const [placement, setPlacement] = useState("top");
  const getPopoverStyle = () => {
    if (!reactionRef.current || !isInsights || isMiniListOpen || stopTranslate || isPedigree) return {};
    const rect = reactionRef.current.getBoundingClientRect();
    const transformX = rect.left - 30;
    return { transform: `translate(${transformX}px, 0)` };
  };
  const handleReactionClick = (emoji) => {
    setSelectedEmoji(emoji);
    if (!isInsights)
      handleReaction(text, emoji.reaction, comments, parentText);
  };
  const updateComment = (comment) => {
    setComments(comment);
    if (!isInsights)
      handleReaction(text, selectedEmoji.reaction, comment, parentText);
  };
  const EMOJI_SET = [
    { reaction: REACTIONS.LIKE, fontSize: "18px", className: "like-emoji" },
    {
      reaction: REACTIONS.DISLIKE,
      fontSize: "18px",
      className: "dislike-emoji",
    },
    { reaction: REACTIONS.UNSURE, fontSize: "16px", className: "unsure-emoji" },
  ];

  useEffect(() => {
    selectedEmojiRef.current = selectedEmoji;
  }, [selectedEmoji]);

  const openReactionModal = () => {
    setShowPopup(true);
    if (reactionRef.current) {
      const rect = reactionRef.current.getBoundingClientRect();
      const isEnoughSpaceOnTop = rect.top > 60;
      setPlacement(isEnoughSpaceOnTop ? "top" : "bottom");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const popoverElement = ReactDOM.findDOMNode(popoverRef.current);
      if (
        popoverElement &&
        !popoverElement.contains(event.target) &&
        showPopup
      ) {
        setShowPopup(false);
        if (isInsights && selectedEmojiRef.current?.reaction)
          handleReaction(text, selectedEmojiRef.current.reaction, comments, parentText);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showPopup, comments]);

  useEffect(() => {
    onVisibilityChange(showPopup);
    return () => {
      onVisibilityChange(false);
    };
  }, [showPopup, onVisibilityChange]);

  useEffect(() => {
    const scrollContainer = document.getElementById('aiInsightsCustomScroll');
    if (!scrollContainer) return;

    const handleScroll = () => {
      if (showPopup)
        setShowPopup(false);
    };

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [showPopup]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setShowPopup(false);
      if (isInsights && selectedEmojiRef.current?.reaction)
        handleReaction(text, selectedEmojiRef.current.reaction, comments, parentText);
    }
  };

  return (
    <>
      <div ref={reactionRef}>
        {selectedEmoji ? (
          <div
            className={`selected-emoji ${selectedEmoji.className}`}
            onClick={!isInsights ? openReactionModal : null}
            style={{ fontSize: selectedEmoji.fontSize }}
          ></div>
        ) : (
          <span className={`emoji ${showPopup ? "active" : ""}`}>
            <AddFeedbackIcon onClick={openReactionModal} />
          </span>
        )}
      </div>
      <Overlay
        show={showPopup}
        placement={placement}
        target={reactionRef.current}
      >
        <Popover
          id="reaction-popover"
          ref={popoverRef}
          className="reaction-popover"
          style={{...getPopoverStyle(), '--translateX': `translate(${translateX}px)`, '--arrowTransformX': `${arrowTransformX}%` }}
        >
          {EMOJI_SET.map((emoji, index) => {
            return (
              <div
                className={`emoji-container ${selectedEmoji?.reaction === emoji.reaction ? "active" : ""
                  }`}
                key={index}
              >
                <div
                  className={`${emoji.className} emoji`}
                  onClick={() => handleReactionClick(emoji)}
                ></div>
              </div>
            );
          })}
          <input
            type="text"
            disabled={!selectedEmoji}
            placeholder="Enter feedback(optional)"
            value={comments}
            onChange={(e) => updateComment(e.target.value)}
            onKeyDown={handleKeyPress}
            onClick={(e) => {
              if (!e.currentTarget.readOnly) {
                e.currentTarget.focus();
              }
            }}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: !selectedEmoji ? "not-allowed" : "text",
            }}
          />
        </Popover>
      </Overlay>
    </>
  );
};

export default AIReactionModal;
